//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { createNamespacedHelpers } from 'vuex'
import RbPdpKlarnaAfterpayPanel from '@/elements/pay-over-time/rb-pay-over-time-panel.vue'
import RbLensDetailsPanel from '@/elements/one-configurator/lens-details-panel.vue'
import RbPanel from '@/elements/panel/rb-panel.vue'

const { mapGetters: mapGettersPdp } = createNamespacedHelpers('pdp')

export default {
  name: 'rb-one-configurator-test',
  components: {
    RbPdpKlarnaAfterpayPanel,
    RbLensDetailsPanel,
    RbPanel,
  },
  data() {
    return {}
  },
  computed: {
    ...mapGettersPdp(['ui']),
  },
  methods: {
    openPayOverTimePanel() {
      window.triggerVueMethod('showPayOverTimeModal')
    },
    openLensDetailsPanel() {
      window.triggerVueMethod('showLensDetailsPanel', {
        cLens: '0058C',
      })
    },
  },
}
